var React = require('react');

function IconLine16IconLineArrowRight16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#091E42","strokeLinecap":"round","strokeLinejoin":"round","d":"M.5 8h15M8.5 15l7-7-7-7"}));
}

IconLine16IconLineArrowRight16.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = IconLine16IconLineArrowRight16;

IconLine16IconLineArrowRight16.default = IconLine16IconLineArrowRight16;
